import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";

import { GiPlainCircle } from "react-icons/gi";
import { IoBedOutline } from "react-icons/io5";
import GlobalImage from "../../../../global/image/image";
import LikeProperty from "../../../../global/like-property";
import StarRating from "../../../../global/star-rating/StarRating";
import NoImage from "../../../../../assets/image_not_supported.svg";
import CurrencyConvertor from "../../../../global/currency-convertor";
import { replaceImageUrlSize } from "../../../../../utils/image";
import UserInputViewer from "../../../../global/UserInputViewer";

import "./styles.css";
import toggleClass from "../../../../../utils/dom/toggle-class.util";

const PropertyDetails = ({ property, isLoading, params, setAvailableProperties, likePropertyId, isActivateByHover = false }) => {
  const checkinDate = params?.bookingDates?.checkinDate;
  const checkoutDate = params?.bookingDates?.checkoutDate;
  const adults = params?.guests?.adultCount;
  const child = params?.guests?.childCount;
  const _childAges = params?.guests?.childAges;
  const rooms = params?.guests?.roomCount;

  function getNumberOfNights(checkInDateStr, checkOutDateStr) {
    const oneDayMs = 86400000;
    const checkInDate = new Date(checkInDateStr);
    const checkOutDate = new Date(checkOutDateStr);
    const timeDiffMs = checkOutDate.getTime() - checkInDate.getTime();
    return Math.ceil(timeDiffMs / oneDayMs);
  }

  const numberOfNights = getNumberOfNights(checkinDate, checkoutDate);

  const totalBedCounts = property.availableRooms.reduce((total, room) => {
    const subRoomsBedsCount = room.subRooms.reduce((subTotal, subRoom) => {
      return subTotal + subRoom.beds.reduce((sum, bed) => sum + bed.quantity, 0);
    }, 0);
    return total + subRoomsBedsCount;
  }, 0);

  const totalBedRoomsCounts = property.availableRooms.reduce((total, room) => {
    const subRoomsBedRoomsCounts = room.subRooms.reduce((subTotal, subRoom) => {
      return subTotal + subRoom.units;
    }, 0);
    return total + subRoomsBedRoomsCounts;
  }, 0);

  const basePrice = property?.basePrice;
  const finalPrice = property?.finalPrice;

  const TotalTaxRate = property?.totalTaxRate ?? 0;
  const tax = TotalTaxRate * finalPrice;

  const hippoOfferRate = property.hippoOfferRate ? Number((property.hippoOfferRate * 100).toFixed(2)) : 0;

  let discountType = hippoOfferRate > 0 ? "hippoOffer" : "";

  const getElements = () => {
    const preElement = document.querySelector(`.advance-marker[data-property-id='${property.id}']`);
    const element = document.querySelector(`.map-marker[data-property-id='${property.id}']`);
    const imgElement = document.querySelector(`.marker-img[hover-img-id='${property.id}']`);
    return { element, imgElement, preElement };
  };

  const mouseOver = () => {
    if (!isActivateByHover) return;

    const { element, imgElement, preElement } = getElements();
    if (element && imgElement && preElement) {
      toggleClass(element, "animate", true);
      toggleClass(imgElement, "animate", true);
      toggleClass(preElement, "marker-hover", true);
    }
  };

  const mouseLeave = () => {
    const { element, imgElement, preElement } = getElements();

    if (element && imgElement && preElement) {
      toggleClass(element, "animate", false);
      toggleClass(imgElement, "animate", false);
      toggleClass(preElement, "marker-hover", false);
    }
  };

  const navigateURL = `/property/${property?.id}/${property?.name}?checkin=${checkinDate}&checkout=${checkoutDate}&adults=${adults}&children=${
    child ?? 0
  }${_childAges}&rooms=${rooms}`;

  const isPropertyAvailable = finalPrice > 0;

  return (
    <Link
      to={navigateURL}
      className="property-details-modal"
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
      style={{
        // opacity: isLoading ? 0.4 : 1,
        overflowY: isLoading ? "hidden" : "auto",
      }}
      target="_blank"
    >
      <div className="property-image-isliked">
        {property?.defaultImage ? (
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={replaceImageUrlSize(property?.defaultImage, "medium")}
              alt="Building"
              className="building skeleton-loading"
            />
            <GlobalImage
              src={replaceImageUrlSize(property?.defaultImage, "square")}
              alt="Building"
              className="property-details-modal-img "
              loading="lazy"
            />
          </picture>
        ) : (
          <img
            src={NoImage}
            alt="Not Available"
            className="building"
            onLoad={(e) => {
              toggleClass(e.target, "skeleton-loading", false);
            }}
          />
        )}
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          className="like-property-icon"
        >
          <LikeProperty
            propertyId={likePropertyId}
            isLiked={property?.isLiked}
            handleLike={(propertyId, liked) => {
              setAvailableProperties((prev) => {
                return prev.map((property) => {
                  if (property.id === propertyId) {
                    return { ...property, isLiked: !liked };
                  }
                  return property;
                });
              });
            }}
          />
        </div>
      </div>
      <div className="property-details">
        <div className="property-details-name-reviews">
          <UserInputViewer tag="h4" className="property-name" text={property.name} />
          {property?.reviewSummary.reviewerCount > 0 && (
            <div className="property-details-reviews">
              <div className="reviews-over-all-score">{property?.reviewSummary.overallScore.toFixed(1)}</div>
              <div className="review-count">
                {property?.reviewSummary.reviewerCount} review
                {property?.reviewSummary.reviewerCount > 1 && "s"}
              </div>
            </div>
          )}
        </div>
        <StarRating rating={property?.rating} />

        {isPropertyAvailable ? (
          <>
            {property.sellType === "ENTIRE_PROPERTY" && (
              <div className="entire-property-details">
                {property.availableRooms.map((roomType) => {
                  return (
                    <>
                      <div className="entire-property-single">
                        <span className="entire-property-type">
                          <GiPlainCircle color="#453266" />
                          <div style={{ display: "inline" }}>Entire {_.startCase(_.toLower(property.type))} :</div>
                        </span>
                        <div className="entire-property-extra-details">
                          <ul className="entire-property-extra-detail">
                            <li>
                              <span>
                                {totalBedRoomsCounts} bedroom
                                {totalBedRoomsCounts > 1 ? "s" : ""}
                              </span>
                            </li>
                            <li>
                              <span>
                                {totalBedCounts} bed
                                {totalBedCounts > 1 ? "s" : ""}
                              </span>
                            </li>
                            {roomType.features.map((feature, i) => {
                              let { name, count } = feature;
                              if (count > 1) name = name + "s";
                              return (
                                <li key={i}>
                                  <span>
                                    {count} {name}
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                          {!_.isEmpty(roomType.rateplan.cancellationPolicy.cancellationUntilDate) && (
                            <div className="entire-property-cancellation-policy">Free cancellation</div>
                          )}
                          <div className="entire-property-max-availability">
                            Only {roomType.maxAvailability} room
                            {roomType.maxAvailability > 1 ? "s" : ""} left at this price on our site
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
            {property.sellType === "PRIVATE_ROOM" && (
              <div className="private-room-details">
                {property.availableRooms.map((roomType) => (
                  <div>
                    <div className="private-room-name">
                      <GiPlainCircle color="#453266" />
                      <span key={roomType.id}>
                        {roomType.rateplan.selectedUnits} x {roomType.name}
                      </span>
                    </div>
                    <div className="private-room-bed">
                      <IoBedOutline color="#453266" fontSize="large" />
                      {roomType.beds.map((bed, index) => {
                        const bed_type = bed.type.split(" /")[0];
                        return (
                          <span key={index}>
                            {index !== 0 && " , "}
                            {bed.quantity} {bed_type}
                            {bed.quantity > 1 ? "s" : ""}
                          </span>
                        );
                      })}
                    </div>
                    <div className="private-room-rate-plan">{roomType.rateplan.mealPlanType}</div>
                    {!_.isEmpty(roomType.rateplan.cancellationPolicy.cancellationUntilDate) && (
                      <div className="private-room-cancellation-policy">Free cancellation</div>
                    )}
                    <div className="private-room-max-availability">
                      Only {roomType.maxAvailability} room
                      {roomType.maxAvailability > 1 ? "s" : ""} left at this price on our site
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="adult-count">
              {numberOfNights} Night
              {numberOfNights > 1 ? "s" : ""}, {adults} Adult
              {adults > 1 ? "s" : ""},{child}
              {child > 1 ? "Children" : "child"}
            </div>
            <div className="price-adult-count">
              {basePrice !== finalPrice && <CurrencyConvertor className="cut-price" price={basePrice} />}
              <CurrencyConvertor price={finalPrice} primaryDiscountType={discountType} className="final-price" />
            </div>
            <div>
              {TotalTaxRate > 0 ? (
                <div className="include-tax">
                  +<CurrencyConvertor price={tax} />
                  &nbsp; taxes and charges
                </div>
              ) : (
                <div className="include-tax">Includes taxes and charges</div>
              )}
            </div>
          </>
        ) : (
          <div class="not-available-card">
            <p>This property is not available for the dates you’ve selected.</p>
          </div>
        )}
      </div>
    </Link>
  );
};

export default PropertyDetails;
